// Extracted chat agent page wrappers to stay under 300-line file limit
import { AppLayoutMemo } from '@/components/layout';
import { ChatSessionHistoryPage } from '@/pages/insurance/ChatSessionHistoryPage';
import { ChatSessionDetailPage } from '@/pages/insurance/ChatSessionDetailPage';

export function ChatSessionHistoryPageWrapper() {
  return (
    <AppLayoutMemo>
      <ChatSessionHistoryPage />
    </AppLayoutMemo>
  );
}

export function ChatSessionDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <ChatSessionDetailPage />
    </AppLayoutMemo>
  );
}
